import { FC } from "react";
import {
  Input,
  Radio,
  Button,
  ButtonSize,
  ButtonVariant,
  IconButton,
  IconButtonSize,
  Checkbox
} from "shared/components";
import { BankAccount } from "types/billing";
import { useForm } from "shared/hooks";
import { statementsValidations } from "../validations";
import { XClose } from "untitledui-js-base";

interface ManualEntryFormProps {
  onSubmitBankAccount: (updates: BankAccount) => void;
  onDismiss: () => void;
}

export const ManualEntryForm: FC<ManualEntryFormProps> = ({
  onSubmitBankAccount,
  onDismiss
}) => {
  const { register, handleChange, onSubmit, values, errors } = useForm(
    {
      account_subtype: "checking",
      account_number: "",
      routing_number: "",
      account_nickname: "",
      name: "",
      default: false
    },
    statementsValidations
  );

  return (
    <form
      className="p-6 flex flex-col h-full"
      onSubmit={onSubmit({
        onSuccess: (values) => {
          // Update both if either is missing
          onSubmitBankAccount(
            // Note: It's not full bank account. It's missing ids and last4
            values as BankAccount
          );
        }
      })}
    >
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-xl font-bold text-content-1000">
          Enter your ACH details
        </h3>
        <IconButton
          size={IconButtonSize.SM}
          onClick={onDismiss}
          Icon={XClose}
          borderLess
          className="translate-x-2"
        />
      </div>
      <div className="mb-6">
        <div className="flex gap-4">
          <Radio
            id="checking"
            checked={values.account_subtype === "checking"}
            onChange={handleChange("account_subtype", (v) =>
              v.target.checked ? "checking" : "savings"
            )}
            name="accountType"
            key="checking"
            label="Checking"
          />
          <Radio
            id="savings"
            checked={values.account_subtype === "savings"}
            onChange={handleChange("account_subtype", (v) =>
              v.target.checked ? "savings" : "checking"
            )}
            name="accountType"
            key="savings"
            label="Savings"
          />
        </div>
        {errors.account_subtype ? (
          <p className="pt-4 text-xs text-danger-500">
            {errors.account_subtype}
          </p>
        ) : null}
      </div>
      <div className="mb-4">
        <Input
          id="account_number"
          label="Account Number"
          placeholder="123456789"
          maxLength={17}
          {...register("account_number")}
          hideOptional
          type="number"
          noIntlNormalization
        />
      </div>
      <div className="mb-4">
        <Input
          id="routing_number"
          label="Routing Number"
          placeholder="123456789"
          maxLength={9}
          {...register("routing_number")}
          hideOptional
          type="number"
          noIntlNormalization
        />
      </div>
      <div className="mb-4">
        <Input
          id="account_nickname"
          placeholder="My Bank Account"
          label="Account Nickname"
          {...register("name")}
          hideOptional
        />
      </div>
      <Checkbox {...register("default")} id="default" label="Mark as default" />

      <div className="mt-auto">
        <Button
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.BASE}
          type="submit"
          className="w-full"
        >
          Link Bank Account
        </Button>
      </div>
    </form>
  );
};
